import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { formatDateTimeWithSeconds } from '../../../../util/time-helpers';
import { savePDF } from '@progress/kendo-react-pdf';
import { DownloadForm, PageTemplate } from './download-form';
import { FluentButton } from '../../../../components/FluentUI/Fluent-Button';
import FluentUiIcon from '../../../../assets/fluent-ui-icon';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import PropTypes from "prop-types";

const DownloadFormModal = ({ formId, setFormId, taskId, valueName, userName }) => {

    const ExportPDFWithMethod = () => {
        let pdfName = `${valueName}-${formId.Name}-exported_by-${userName}-on-${formatDateTimeWithSeconds(new Date())}.pdf`;

        let element = document.querySelector(".download-form");
        savePDF(element, {
            paperSize: "A4",
            keepTogether: ".field",
            forcePageBreak: ".page-break",
            fileName: pdfName,
            pageTemplate: PageTemplate,
        });
    };

    return (
        <Modal
            show={formId !== null}
            onHide={() => setFormId(null)}
            contentClassName="formModal"
        >
            <Modal.Header>
                <Modal.Title className="modal-title">
                    <div className="download-button">
                        <h3>Preview and Download</h3>
                        <FluentProvider theme={webLightTheme}>
                            <FluentButton
                                icon={
                                    <FluentUiIcon
                                        name={"ArrowDownloadRegular"}
                                        color={"#0F6CBD"}
                                        size={20}
                                    />
                                }
                                text={"Download PDF"}
                                onClick={() => ExportPDFWithMethod()}
                            />
                        </FluentProvider>
                    </div>
                </Modal.Title>
                <Button
                    className="close-document-viewer-btn btn-primary"
                    onClick={() => setFormId(null)}
                ></Button>
            </Modal.Header>
            <Modal.Body className="formModal">
                <FluentProvider theme={webLightTheme}>
                    <DownloadForm
                        formId={formId.Id}
                        taskId={taskId}
                        taskName={valueName}
                    ></DownloadForm>
                </FluentProvider>
            </Modal.Body>
        </Modal>
    );
};

DownloadFormModal.propTypes = {
    formId: PropTypes.shape({
      Id: PropTypes.string.isRequired,
      Name: PropTypes.string.isRequired,
    }),
    setFormId: PropTypes.func.isRequired,
    taskId: PropTypes.string.isRequired,
    valueName: PropTypes.string.isRequired,
    userName: PropTypes.string.isRequired,
  };

export default DownloadFormModal;